import Metrics from '../Metrics'
import { BoxSizes, Chart, Dashboard } from './types'

const Main: Dashboard = {
    id: 'MAIN',
    name: 'Overview',
    daterange: false,
    metrics: [
        {
            type: Metrics.DEVICES_ONLINE,
            'box-size': BoxSizes.BIG,
            chart: Chart.Doughnut,
            count: 'dashboard-count-devices',
            title: 'dashboard-devices-online',
        },
        {
            type: Metrics.DEVICES_TYPES,
            'box-size': BoxSizes.BIG,
            chart: Chart.Bars,
            count: 'dashboard-count-devices',
            title: 'dashboard-devices-types',
        },
        {
            type: Metrics.NOTES_LATEST,
            'box-size': BoxSizes.SMALL,
            link: 'ESTATE_STORE',
            title: 'dashboard-notes-latest',
        },
        {
            type: Metrics.PLAYLISTS_LATEST,
            'box-size': BoxSizes.SMALL,
            icon: 'screen',
            title: 'dashboard-playlists-latest',
        },
        {
            type: Metrics.MEDIA_LATEST,
            'box-size': BoxSizes.SMALL,
            icon: 'thumbnail',
            title: 'dashboard-media-latest',
        },
        {
            type: Metrics.PLAYLISTS_SCHEDULED_NEXT,
            'box-size': BoxSizes.SMALL,
            title: 'dashboard-playlists-scheduled-next',
        },
        {
            type: Metrics.MEDIA_SCHEDULED_NEXT,
            'box-size': BoxSizes.SMALL,
            title: 'dashboard-media-scheduled-next',
        }
    ],
}

export default Main
